import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { DPFormField } from 'src/app/core/models/DPFormField';

/**
 * Single line text input component.
 * 
 * The value is the entered text.
 */
@Component({
  selector: 'app-single-line',
  standalone: true,
  imports: [NgClass, ReactiveFormsModule],
  templateUrl: './single-line.component.html',
  styleUrls: ['./single-line.component.scss'],
})
export class SingleLineComponent implements OnInit, AfterViewInit {
  @Input() field: DPFormField;
  @Input() control: UntypedFormControl;
  @Input() disabled: boolean;

  @ViewChild('input') inputEl: ElementRef<HTMLInputElement>;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.field.autoFocus && this.inputEl) {
      /**
       * If the field is autoFocus field, focus the input after view init.
       */
      setTimeout(() => {
        this.inputEl.nativeElement.focus();
        this.inputEl.nativeElement.setSelectionRange(0, 0);
      }, 100);
    }
  }

  /**
   * If the input is number, it enforces only numbers and "-" are entered.
   */
  handleInput(ev: Event) {
    if (this.field.inputType === 'number') {
      const target = ev.target as HTMLInputElement;
      const v = target.value.replace(/[^\d]/g, '');
      target.value = v;
      if (this.control && this.control.value !== v) {
        this.control.setValue(target.value);
      }
    }
  }

  /**
   * If the input is number, it handles paste event.
   *
   * It gets clipboard value, filter only numbers and add the numbers in cursor position.
   */
  handlePaste(ev: ClipboardEvent) {
    if (this.field.inputType === 'number') {
      const data = ev.clipboardData.getData('text').replace(/[^\d]/g, '');
      ev.preventDefault();

      if (data.length > 0) {
        const value = this.inputEl.nativeElement.value;
        const start = this.inputEl.nativeElement.selectionStart;
        const end = this.inputEl.nativeElement.selectionEnd;
        const newValue = value.slice(0, start) + data + value.slice(end);
        this.inputEl.nativeElement.value = newValue;
        this.inputEl.nativeElement.setSelectionRange(
          start + data.length,
          start + data.length
        );
        // Update the form control with the new value
        if (this.control) {
          this.control.setValue(newValue);
        }
      }
    }
  }
}
